"use strict";

exports.__esModule = true;
var _CreateDeviceScreenPlantTwin = require("./CreateDeviceScreenPlantTwin");
Object.keys(_CreateDeviceScreenPlantTwin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateDeviceScreenPlantTwin[key]) return;
  exports[key] = _CreateDeviceScreenPlantTwin[key];
});